<template>
  <div class="ms-container">
    <law-cases-page type="project" />
  </div>
</template>

<script>
import LawCasesPage from '@/components/law-cases/law-cases-page'

export default {
  components: {
    LawCasesPage
  }
}
</script>

<style></style>
